import React, { Component } from 'react'
import FieldsList from './FieldsList'
import StagesManager from './StagesManager'
import FieldsData from './FieldsData'
import { translate } from '../utils/useful'
import { v4 as uuidv4 } from 'uuid';
import ButtonAnimated from './buttons/ButtonAnimated'

export default class AddFieldsList extends Component {

    state = {
        backbtn: false,
        isLoading: false
    }

    componentDidMount() { }

    setField = (prop) => {
        // console.log('propsetfield', prop)
        this.setState({ field: prop }, () => {
            this.stageManager.changeStage('form')
            this.setState({ backbtn: true })
        })
    }

    BackStage = () => {
        this.stageManager.lastStage()
        this.setState({ backbtn: false })
    }

    addField = () => {
        let currentField = this.props.currentField ? this.props.currentField : {}
        let data = currentField ?? null
        // let form = this.form.getForm()
        if (!currentField?.key) {
            let id = uuidv4()
            data.field = {}
            data.field.id = id
            data.field.key = 'values.' + id
            data.field.type = this.state.field?.type
        }
        let information = this.FieldsData.getForm()

        // console.log('informationinformation',information)
        data.form = this.props.page?._id
        if (information) {
            data.field.information = information
            if (this.state.field.type == 'StageInput') {
                data.field.hideComponent = true
            }

            data.field.section = 'sec-custom'
            // data.field.pages = ["information"]

            this.props.setIsLoadingAddField(true)
            this.setState({ isLoading: true })
            this.props.addField(data, () => {
                this.setState({ isLoading: false })
            })
        }
    }

    render() {
        return (
            <div className='  h-100 white-bg'>
                <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '12px 14px', background: this.props.colors?.background, zIndex: 2, borderBottom: '1px solid #eee', height: 60 }}>
                    <div className='flexc' style={{}}>
                        {this.state.backbtn == true &&
                            <button onClick={this.BackStage}>
                                <img width={18} className='mrd-2 flexcc ' src='/assets/icons/arrow-left-white.svg' />
                            </button>
                        }
                        <p className=' font-size-14 text-semibold' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{translate('Add Custom Field')}</p>
                        {/* {this.state.field?.label &&
                            <p className=' font-size-14 text-semibold' style={{ color: this.props.colors?.textColor ?? '#fff' }}> - {checkTranslation(this.state.field?.label)}</p>
                        } */}
                        {/* <button className='purple-btn w-100 mx-2 py-2 br-5' onClick={() => this.addField()}>
                            <p>{translate('Submit')}</p>
                        </button> */}
                    </div>
                    {this.state.backbtn == true &&
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={() => { !this.state.isLoading && this.addField() }}
                            title={translate('Submit')}
                            icon='/assets/icons/plus-white.svg'
                            textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                            invert={!this.props.colors?.iconInvert}
                            bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                            isLoading={this.state.isLoading}
                        />
                    }
                </div>
                <div className='scroll-no-scrollbar' style={{ height: 'calc(100% - 60px)' }}>
                    <StagesManager ref={el => this.stageManager = el} fast={true}>
                        <FieldsList addField={this.props.addField} currentFrame={this.props.currentFrame} width={this.props.width} changeStage={this.changePage} stage={0} stageName={'lists'} setField={this.setField} />
                        <FieldsData ref={el => this.FieldsData = el} colors={this.props.colors} addField={this.props.addField} currentFrame={this.props.currentFrame} width={this.props.width} changeStage={this.changePage} stage={1} stageName={'form'} field={this.state.field} initData={this.props.page} params={this.props.params} variables={this.props.variables} />
                    </StagesManager>
                </div>
            </div >
        )
    }
}